import styled from 'styled-components'

import { timingDefault } from '@syconium/little-miss-figgy'

// Marks size themselves against the frame's width, so it is a size container.
export const Frame = styled.div`
  aspect-ratio: 1;
  container-type: inline-size;
  max-width: 640px;
  position: relative;
  width: 100%;
`

/** A layer that fills its containing block and fades in and out as focus comes and goes. */
export const Layer = styled.div<{ $isVisible: boolean }>`
  inset: 0;
  opacity: ${o => (o.$isVisible ? 1 : 0)};
  pointer-events: ${o => (o.$isVisible ? 'auto' : 'none')};
  position: absolute;
  transition: opacity ${timingDefault} ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

// Fills the modal's whole preview half, its containing block, so the marks center on the modal's
// height. Marks size themselves against its width.
export const CloseUp = styled(Layer)`
  container-type: inline-size;
`
